import React, { useState, useEffect } from 'react';
import { Table, Button, Drawer, Checkbox, Toggle, ExpandableSection, FlashbarProps, Flashbar, HelpPanel, SplitPanel, Link, Alert, KeyValuePairs } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import Pagination from '@cloudscape-design/components/pagination';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { formatPhone, storeJWT } from '../../../commons/functions';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiAlert, mdiHelpCircleOutline } from '@mdi/js';
import Icon from '@mdi/react';

const pageSize = 20;

export const AdminUsersPage = () => {
    const storeAdmin = useStoreAdmin();
    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);

    const [pendingJobCreation, setPendingJobCreation] = useState(false);
    const { idPropiedad, setIdPropiedad } = useGlobalState();
    const { JWT, setJWT } = useGlobalState();
    const { idControl, setIdControl } = useGlobalState();

    const [helpOpen, setHelpOpen] = useState(false);
    const [sideOpen, setSideOpen] = useState(false);

    const [btnAuths, setBtnAuths] = useState(true);
    const [idControlDelete, setIdControlDelete] = useState(0);
    const [isInternalUsers, setIsInternalUsers] = useState(0);
    const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
    const [selectedNotifications, setSelectedNotifications] = useState<string[]>([]);
    const [selectedAdminFunctions, setSelectedAdminFunctions] = useState<string[]>([]);

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const [selectedItems, setSelectedItems] = useState<UserItem[]>([]);
    const { setLoading } = useGlobalState();
    const [isActiveAdminFunciones, setIsActiveAdminFunciones] = useState<number>(0);
    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filteringText, setFilteringText] = useState('');

    const [selectedRow, setSelectedRow] = useState<UserItem | null>(null);

    const [users, setUsers] = useState<UserItem[]>([]);
    const [user, setUser] = useState<UserItem>();



    type UserItem = {
        idControl: number,
        displayName: string,
        movil: string,
        email: string,
        adminFunctions: any[],
        notifications: any[],
        isActiveAdminFunciones: number,
        idAdminFunciones: number,
        adminMenu: MenuItem[],
        isInternalUsers: number;

    };
    type MenuItem = {
        idMenu: number;
        text: string;
        href: string;
        enable: boolean;
        menus: MenuItem[];
    };

    const initialData = {
        adminMenu: [] as MenuItem[]
    };
    const [menuData, setMenuData] = useState<MenuItem[]>(initialData.adminMenu);
    const [jsonMenu, setJsonMenu] = useState<number[]>([]);

    useEffect(() => {
        const ids: number[] | ((prevState: never[]) => never[]) = [];
        menuData.forEach(menu => {
            if (menu.enable) ids.push(menu.idMenu);
            menu.menus?.forEach(child => {
                if (child.enable) ids.push(child.idMenu);
            });
        });

        setJsonMenu(ids);
    }, [menuData]);
    const handleParentToggle = (parentId: number) => {
        setMenuData((prev) =>
            prev.map((item) => {
                if (item.idMenu === parentId) {
                    const newEnable = !item.enable;
                    return {
                        ...item,
                        enable: newEnable,
                        menus: item.menus.map((child) => ({
                            ...child,
                            enable: newEnable
                        }))
                    };
                }
                return item;
            })
        );
    };

    const handleChildToggle = (parentId: number, childId: number) => {
        setMenuData((prev) =>
            prev.map((item) => {
                if (item.idMenu === parentId) {
                    const newMenus = item.menus.map((child) =>
                        child.idMenu === childId
                            ? { ...child, enable: !child.enable }
                            : child
                    );
                    const anyChildEnabled = newMenus.some((c) => c.enable);
                    return {
                        ...item,
                        enable: anyChildEnabled,
                        menus: newMenus
                    };
                }
                return item;
            })
        );
    };

    const filteredUsers = users.filter(users => {
        const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
        return searchWords.every(word =>
            users.displayName.toLowerCase().includes(word) ||
            users.movil.toLowerCase().includes(word) ||
            users.email.toLowerCase().includes(word)
        );
    });

    const paginatedUsers = filteredUsers.slice(
        (currentPageIndex - 1) * pageSize,
        currentPageIndex * pageSize
    );


    useEffect(() => {
        setBtnAuths(selectedUsers.length == 0)
    }, [selectedUsers]); // The effect runs every time selectedAccesses changes

    // Handle row click to fetch additional data and open the HelpPanel
    const handleRowClick = async (rowData: UserItem) => {
        // Store selected row data

        setIsActiveAdminFunciones(rowData.isActiveAdminFunciones)
        setSelectedNotifications(rowData.notifications);
        setSelectedAdminFunctions(rowData.adminFunctions);
        setIsInternalUsers(rowData.isInternalUsers);

        setUser(rowData)

        setMenuData(rowData.adminMenu);
        setIdControlDelete(rowData.idControl);
        //console.log(rowData.notifications)
        setLoading(true);
        try {
            setSelectedRow(rowData);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);

            setHelpOpen(false);
            setSideOpen(true);
        }
    };
    useEffect(() => {
    }, [selectedRow]);
    const handleRefresh = async () => {
        setHelpOpen(false);
        setSideOpen(false);
        setPendingJobCreation(true)
        try {
            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/admins/list',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            storeAdmin(data);
            if (data.admins) setUsers(data.admins);
            if (data && data.admin && data.admin.adminFunciones) {
                if (!data.admin.adminFunciones.notifications.includes("INTERNAL.USERS")) {
                    window.location.href = "#home"
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
            setPendingJobCreation(false)
        }
    };


    useEffect(() => {
        //console.log(users)
    }, [users]);

    useEffect(() => {
        handleRefresh();
    }, []);

    useEffect(() => {
        //console.log(selectedNotifications);
    }, [selectedNotifications]);
    const handleChangeNotification = (notification: string) => {
        //console.log("handleChangeNotification called with:", notification, event);
        setSelectedNotifications((prev) => {
            // If the access is already selected, remove it from the array, else add it
            if (prev.includes(notification)) {
                return prev.filter(id => id !== notification);
            } else {
                return [...prev, notification];
            }
        });
    };
    const handleChangeAdminFunction = (adminFunction: string) => {

        setSelectedAdminFunctions((prev) => {
            // If the access is already selected, remove it from the array, else add it
            if (prev.includes(adminFunction)) {
                return prev.filter(id => id !== adminFunction);
            } else {
                return [...prev, adminFunction];
            }
        });
    };
    //'System.Object[]'
    const btnUserDelete = async () => {
        setPendingJobCreation(true)
        try {


            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/users/delete.user',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    idControl: idControlDelete,

                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            storeAdmin(data);
            if (data.code === 0) {
                setMessages([
                    {
                        type: 'success',
                        content: 'Usuario ha sido eliminado',
                        id: 'error-msg',
                        dismissible: true,
                        onDismiss: () => {
                            setMessages((prev) => prev.filter((msg) => msg.id !== 'error-msg'));
                        }
                    },
                ]);
                handleRefresh()
            }
            //setUsers(data.admins);

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
            setPendingJobCreation(false);
            handleRefresh();
        }

    }
    const btnUserSave = async () => {
        setPendingJobCreation(true)
        try {


            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/admins/mod.user',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    idAdminFunciones: user?.idAdminFunciones,
                    adminFunctions: selectedAdminFunctions,
                    notifications: selectedNotifications,
                    isActiveAdminFunciones: isActiveAdminFunciones,
                    jsonMenu: jsonMenu,

                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            storeAdmin(data);
            if (data.code === 0) {
                setMessages([
                    {
                        type: 'success',
                        content: 'Usuario ha sido actualizado correctamente',
                        id: 'error-msg',
                        dismissible: true,
                        onDismiss: () => {
                            setMessages((prev) => prev.filter((msg) => msg.id !== 'error-msg'));
                        }
                    },
                ]);
            }
            //setUsers(data.admins);

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
            setPendingJobCreation(false);
            handleRefresh();
        }
    };
    return (
        <CustomAppLayout
            toolsOpen={helpOpen}
            onToolsChange={({ detail }) => setHelpOpen(detail.open)}
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}

            tools={
                helpOpen && (
                    <HelpPanel
                        header={
                            <Header variant="h2">Ayuda</Header>
                        }
                    ><p>Listado de usuarios que poseen perfil de administrador de la propiedad</p>

                        <p>Para modificar un usuario, haga click sobre el registro. Se desplegará una ventana lateral en donde podra editar las notificaciones, permisos web y permisos de la App para el usuario seleccionado.</p>
                        <p>Para eliminar a un usuario, haga click sobre el registro. Sobre la ventana lateral, presione el botón <em><b>Eliminar</b></em>.</p>

                    </HelpPanel>
                )
            }
            splitPanel={
                <SplitPanel hidePreferencesButton header={selectedRow ? selectedRow.displayName : ''} closeBehavior='hide'>
                    {selectedRow ? (
                        <>
                            <KeyValuePairs
                                columns={2}
                                items={[
                                    {
                                        label: "Móvil",
                                        value: formatPhone(selectedRow.movil)
                                    },
                                    {
                                        label: "Email",
                                        value: selectedRow.email
                                    },
                                ]}
                                />
                            <ExpandableSection headerText="General" defaultExpanded>
                                <SpaceBetween size='xs'>
                                    <Toggle
                                        onChange={({ detail }) =>
                                            setIsActiveAdminFunciones(detail.checked ? 1 : 0)
                                        }
                                        checked={isActiveAdminFunciones === 1}
                                    >
                                        {isActiveAdminFunciones === 1 ? "Activo" : "Inactivo"}

                                    </Toggle>
                                    <p><strong>Notificaciones</strong></p>
                                    <Checkbox onChange={() => handleChangeNotification('INTERNAL.USERS')} checked={selectedNotifications.includes('INTERNAL.USERS')}>Administrar usuarios</Checkbox>
                                    <Checkbox onChange={() => handleChangeNotification('AUTHS')} checked={selectedNotifications.includes('AUTHS')}>Autorizaciones</Checkbox>
                                    <Checkbox onChange={() => handleChangeNotification('INVOICE')} checked={selectedNotifications.includes('INVOICE')}>Facturación</Checkbox>
                                    <Checkbox onChange={() => handleChangeNotification('CONNECTION')} checked={selectedNotifications.includes('CONNECTION')}>Reconexión/Desconexión</Checkbox>
                                    <Checkbox onChange={() => handleChangeNotification('SERVICES')} checked={selectedNotifications.includes('SERVICES')}>Solicitudes servicio</Checkbox>
                                    <Checkbox onChange={() => handleChangeNotification('FACILITIES')} checked={selectedNotifications.includes('FACILITIES')}>Espacios comunes</Checkbox>
                                    <Checkbox onChange={() => handleChangeNotification('OPEN.COMPLETE')} checked={selectedNotifications.includes('OPEN.COMPLETE')}>Aperturas realizadas</Checkbox>
                                </SpaceBetween>
                            </ExpandableSection>
                            <ExpandableSection headerText="Permisos Web">
                                {menuData.map((menu) => (

                                    <div key={menu.idMenu} style={{ marginBottom: '0.5rem' }}>
                                        <Checkbox checked={menu.enable}
                                            key={menu.idMenu}
                                            onChange={() => handleParentToggle(menu.idMenu)}
                                        >
                                            {menu.href !== '' ? <strong>{menu.text}</strong> : menu.text}
                                        </Checkbox>
                                        {menu.menus.length > 0 && (

                                            <div style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
                                                {menu.menus.map((child) => (
                                                    <Checkbox
                                                        checked={child.enable}
                                                        key={child.idMenu}
                                                        onChange={() =>
                                                            handleChildToggle(menu.idMenu, child.idMenu)
                                                        }
                                                    >
                                                        {child.text}
                                                    </Checkbox>

                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </ExpandableSection>
                            <ExpandableSection headerText="Permisos App">


                                <Checkbox onChange={() => handleChangeAdminFunction('UNITS.NOTIFICATIONS')} checked={selectedAdminFunctions.includes('UNITS.NOTIFICATIONS')}>Centro de notificaciones</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('MANUAL.OPEN')} checked={selectedAdminFunctions.includes('MANUAL.OPEN')}>Apertura manual</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('FAILURE.REPORTS')} checked={selectedAdminFunctions.includes('FAILURE.REPORTS')}>Reporte de fallas</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('GUEST')} checked={selectedAdminFunctions.includes('GUEST')}>Verificación de invitados</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('FACILITIES')} checked={selectedAdminFunctions.includes('FACILITIES')}>Reservas espacios comunes</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('REGISTER.USER')} checked={selectedAdminFunctions.includes('REGISTER.USER')}>Agregar usuario</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('AUTH')} checked={selectedAdminFunctions.includes('AUTH')}>Autorizar usuarios</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('EXTSERVICES')} checked={selectedAdminFunctions.includes('EXTSERVICES')}>Autorizacion servicios externos</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('GUEST.AUTH')} checked={selectedAdminFunctions.includes('GUEST.AUTH')}>Autorización de invitaciones</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('LIST')} checked={selectedAdminFunctions.includes('LIST')}>Listado de usuarios</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('DELETE')} checked={selectedAdminFunctions.includes('DELETE')}>Eliminar usuario</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('DELETE.EXTSERVICE')} checked={selectedAdminFunctions.includes('DELETE.EXTSERVICE')}>Eliminar servicio</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('REGISTRY')} checked={selectedAdminFunctions.includes('REGISTRY')}>Bitácora de eventos</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('ACCESS.BLOCK')} checked={selectedAdminFunctions.includes('ACCESS.BLOCK')}>Estado de accesos</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('UNITS.BLOCKS')} checked={selectedAdminFunctions.includes('UNITS.BLOCKS')}>Bloqueo de unidades</Checkbox>
                                <Checkbox onChange={() => handleChangeAdminFunction('CONFIG.DEVICE')} checked={selectedAdminFunctions.includes('CONFIG.DEVICE')}>Configuración de dispositivos</Checkbox>



                            </ExpandableSection>
                            <SpaceBetween direction='vertical' size='xs'>
                                {selectedRow.idControl === idControl && (
                                    <Alert
                                        type="warning"
                                        header="Advertencia"
                                    >
                                        No es posible eliminarse a si mismo
                                    </Alert>
                                )}
                                <SpaceBetween direction='horizontal' size='xs'>
                                    <Button variant="normal" onClick={btnUserDelete} disabled={selectedRow.idControl === idControl}>Eliminar</Button>
                                    <Button variant='primary' onClick={btnUserSave}>Modificar</Button>
                                </SpaceBetween>
                            </SpaceBetween>

                        </>
                    ) : (
                        <p>No hay datos seleccionados.</p>
                    )}
                </SplitPanel>
            }

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Administradores', href: '#admin/default' },
                        { text: 'Usuarios', href: '#transcription-job-list' },
                        /*{ text: 'Listar notificaciones', href: '#create-transcription-job' },*/
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header

                            info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                            actions={
                                <SpaceBetween direction="horizontal" size="xs">

                                    <Button variant="primary" href='#admin/user.add'>
                                        Agregar Administrador
                                    </Button>
                                    <Button variant="primary" onClick={handleRefresh} loading={pendingJobCreation} iconName="refresh"></Button>
                                </SpaceBetween>
                            }
                        /*info={<Link variant="info">Info</Link>}*/
                        >
                            Administradores internos ({users.length})
                        </Header>
                        <Table
                            header={<Flashbar items={messages} />}
                            stripedRows
                            renderAriaLive={({ firstIndex, lastIndex, totalItemsCount }) =>
                                `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`
                            }
                            onRowClick={({ detail }) => handleRowClick(detail.item)}
                            columnDefinitions={[
                                {
                                    id: "idControl",
                                    header: "ID",
                                    cell: (item) => (<>{item.idControl}-{item.idAdminFunciones}</>),
                                    maxWidth: 60
                                },
                                {
                                    id: "displayName",
                                    header: "Usuario",
                                    cell: (item) => (
                                        <>{item.displayName}{' '}{item.isActiveAdminFunciones === 0 ? <Icon path={mdiAlert} color={"red"} size={1}></Icon> : null}</>
                                    ),
                                    isRowHeader: true,
                                },
                                {
                                    id: "movil",
                                    header: "Móvil",
                                    cell: (item) => formatPhone(item.movil),
                                    //sortingField: "unidad",
                                },
                            ]}
                            items={paginatedUsers}
                            //selectionType="multi"
                            trackBy="idControl"
                            empty={
                                <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
                                    <SpaceBetween size="m">
                                        <b>No tiene administradores activos</b>
                                    </SpaceBetween>
                                </Box>
                            }
                            filter={
                                <TextFilter
                                    filteringText={filteringText}
                                    onChange={({ detail }) => {
                                        setFilteringText(detail.filteringText);
                                        setCurrentPageIndex(1);
                                    }}
                                />
                            }
                            pagination={
                                filteredUsers.length > pageSize && (
                                    <Pagination
                                        currentPageIndex={currentPageIndex}
                                        pagesCount={Math.ceil(filteredUsers.length / pageSize)}
                                        onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                    />
                                )
                            }

                        />
                    </SpaceBetween>

                </>
            }
        />
    );
};

function getCheckedMenuIds(adminMenu: any[]) {
    const checkedIds: number[] = [];

    adminMenu.forEach(menu => {
        if (menu.enable) {
            checkedIds.push(menu.idMenu);
        }

        if (menu.menus && Array.isArray(menu.menus)) {
            menu.menus.forEach((submenu: { enable: any; idMenu: any; }) => {
                if (submenu.enable) {
                    checkedIds.push(submenu.idMenu);
                }
            });
        }
    });

    return checkedIds;
}